import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-radioDisabled",
  "use": "icon-radioDisabled-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-radioDisabled\">\n<circle cx=\"12\" cy=\"12\" r=\"9\" fill=\"#E5E5E5\" stroke=\"#C4C4C4\" stroke-width=\"2\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol